export const color1 = '#1e2a3e';
export const color2 = '#dc4d01';
export const color3 = '#f7e4ce';
export const color4 = '#401006';
export const color5 = '#d5d7da';
export const color6 = '#ff5c34'
export const color6_20 = '#ff5c3433'
export const color7 = '#666'
export const color8 = '#ffffff'
export const color9 = '#1a1a1a'
export const color10 = '#d92d20'
export const color11 = '#079455'
export const color12 = '#067647'
export const transactionDateFormat = "D MMM'YY h:mm A";
export const defaultDateFormat = 'DD MMM YY';
export const dateFormat1 = 'YYYY-MM-DD'